<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h1 class="toc-title">CONTENTS</h1>
<h2 class="toca"><a href="#/xhtml/05_Acknowledgements#ack"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter01#chapter1"><span class="tocj">1</span> Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter02#chapter2"><span class="tocj">2</span> History</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter03#chapter3"><span class="tocj">3</span> Biographies and Sources</a></h2>
<h2 class="toc"><a href="#/xhtml/09_Chapter04#chapter4"><span class="tocj">4</span> Hull Design</a></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter05#chapter5" title="Link target outside of Sample"><span class="tocj">5</span> Hull Construction</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter06#chapter6" title="Link target outside of Sample"><span class="tocj">6</span> Pumps</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter07#chapter7" title="Link target outside of Sample"><span class="tocj">7</span> Steering</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter08#chapter8" title="Link target outside of Sample"><span class="tocj">8</span> Ground Tackle</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter09#chapter9" title="Link target outside of Sample"><span class="tocj">9</span> Deck Arrangements and Accommodation</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter10#chapter10" title="Link target outside of Sample"><span class="tocj">10</span> Decoration</span></h2>
<h2 class="toc1"><span href="#/xhtml/15_Chapter10#color" title="Link target outside of Sample"><em class="italic">Colour section</em></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter11#chapter11" title="Link target outside of Sample"><span class="tocj">11</span> Masts and Yards</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter12#chapter12" title="Link target outside of Sample"><span class="tocj">12</span> Sails</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter13#chapter13" title="Link target outside of Sample"><span class="tocj">13</span> Rigging</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter14#chapter14" title="Link target outside of Sample"><span class="tocj">14</span> Ordnance</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter15#chapter15" title="Link target outside of Sample"><span class="tocj">15</span> Boats</span></h2>
<h2 class="toc1"><span href="#/xhtml/22_Plates#plates" title="Link target outside of Sample">Plates</span></h2>
<h2 class="tocs"><span href="#/xhtml/23_Appendix01#app1" title="Link target outside of Sample"><span class="tocs">Appendix I</span> Trinity House Protest</span></h2>
<h2 class="tocs"><span href="#/xhtml/24_Appendix02#app2" title="Link target outside of Sample"><span class="tocs">Appendix II</span> Sail Carrying Capacity</span></h2>
<h2 class="tocat"><span href="#/xhtml/25_Bibliography#bib" title="Link target outside of Sample">Bibliography</span></h2>
<a id="page_6"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?a78de0d4